import { collection, getDocs, query, orderBy, limit, QueryDocumentSnapshot, DocumentData, startAfter, where } from "firebase/firestore";
import Failure from "../../../core/Failure";
import { FirestoreCollections, firestore } from "../../../firebase.config";
import Log from "../../models/Log";
import { LogCategory, LogLevel } from "@leedpulse-monorepo/enums";
import dayjs from "dayjs";

export interface LogFilters {
    type?: LogLevel | null
    category?: LogCategory | null
    period?: [dayjs.Dayjs | null, dayjs.Dayjs | null] | null;
}

async function getLogs(
    lastVisible?: QueryDocumentSnapshot<DocumentData, DocumentData>,
    filters?: LogFilters
): Promise<{
    items: Log[],
    lastVisible: QueryDocumentSnapshot<DocumentData, DocumentData>
}> {
    try {
        const db = firestore;
        const logsCollection = collection(db, FirestoreCollections.logs);
        const constraints = [];
        if (filters && filters.type) {
            constraints.push(where('level', '==', filters.type));
        }
        if (filters && filters.category) {
            constraints.push(where('category', '==', filters.category));
        }
        if (filters && filters.period) {
            filters.period[0] && constraints.push(where('timestamp', '>=', filters.period[0].valueOf()));
            filters.period[1] && constraints.push(where('timestamp', '<=', filters.period[1].valueOf()));
        }
        constraints.push(orderBy("timestamp", "desc"));
        if (lastVisible) {
            constraints.push(startAfter(lastVisible));
        }
        constraints.push(limit(100));
        const results = await getDocs(query(logsCollection, ...constraints));

        const logs: Log[] = [];

        results.docs.forEach((doc) => {
            logs.push(Log.fromFirestore(doc));
        });

        return {
            items: logs,
            lastVisible: results.docs[results.docs.length - 1]
        };
    } catch (e) {
        console.error("error: ", e);
        throw new GetLogsFailure();
    }
}

export class GetLogsFailure extends Failure {
    constructor(message = "Unknown error", code = "unknown-error") {
        super(message, code);
    }
}

export default getLogs;
